import React, { useContext, useEffect, useState } from "react";
import SiteLocaleSelectionList from "./SiteLocaleSelectionList";
import styles from "./siteLocaleSelectionPopupMenu.module.scss";
import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { MagentoStoreContext } from "@sbi-international/boutik.gatsby.plugin.services";
import { MagentoCustomerContext } from "@sbi-international/boutik.gatsby.plugin.services";
import { Icon } from "../primitives";

type SiteLocaleSelectionPopupMenuProps = {
    direction?: string;
};

export default function SiteLocaleSelectionPopupMenu({
    direction = "down",
}: SiteLocaleSelectionPopupMenuProps) {
    let { currentLocaleDefinition } = usePageLocalization();
    const magentoStoreContext = useContext(MagentoStoreContext);
    const magentoCustomerContext = useContext(MagentoCustomerContext);

    const [showList, setShowList] = useState<boolean>(true);
    const [filterLocal, setFilterLocal] = useState<string>('');

    useEffect(() => {        
        if (magentoCustomerContext?.isAuthenticated) {
            setShowList(magentoStoreContext?.currentStore?.toUpperCase().includes("US") !== true);
            setFilterLocal(magentoStoreContext?.currentStore?.includes("us") ? "US" : "CA");
        }
        else {
            setFilterLocal('');
            setShowList(true);
        }
    }, [magentoStoreContext?.currentStore, magentoCustomerContext?.isAuthenticated]);

    let lang = currentLocaleDefinition.langCode;
    let country = currentLocaleDefinition.countryCode;
    let money = country + "d";

    return (
        <div className={styles.localeSelection}>
            <div className={`${styles.currentLocale} ${showList ? "list" : ""}`}>
                <span>
                    {lang.toUpperCase()} | {money.toUpperCase()}
                </span>
                {showList && (
                    <Icon
                        className={styles.chevronDown}
                        d="M2.5,0,5,4H0Z"
                        size="6"
                        transform="translate(5 4) rotate(180)"
                    />
                )}
            </div>
            {showList && (
                <div
                    className={
                        direction === "down"
                            ? styles.localesContainer
                            : `${styles.localesContainer} ${styles.bottom}`
                    }
                >
                    <SiteLocaleSelectionList userStore={magentoStoreContext?.currentStore} filterLocal={filterLocal} />
                </div>
            )}
        </div>
    );
}
